import { maCrossover } from './maCrossover';
import { macroBullet } from './macroBullet';
import { erlIrl } from './erlIrl';
import { vwapAbsorption } from './vwapAbsorption';

const STRATEGIES = [maCrossover, macroBullet, erlIrl, vwapAbsorption];

export function listStrategies() {
  return STRATEGIES.map((s) => ({ id: s.id, name: s.name, paramSchema: s.paramSchema, indicators: s.indicators }));
}

export function getStrategy(id) {
  return STRATEGIES.find((s) => s.id === id) || STRATEGIES[0];
}

export { maCrossover, macroBullet, erlIrl, vwapAbsorption };
